export var RolesPermissionsType;
(function (RolesPermissionsType) {
    RolesPermissionsType["MANAGE_TOURNAMENTS"] = "manageTournaments";
    RolesPermissionsType["MANAGE_PLAYERS"] = "managePlayers";
    RolesPermissionsType["HIDE_TOURNAMENTS"] = "hideTournaments";
    RolesPermissionsType["DELETE_TOURNAMENTS"] = "deleteTournaments";
    RolesPermissionsType["DELETE_PLAYERS"] = "deletePlayers";
    RolesPermissionsType["IMPORT_PLAYERS"] = "importPlayers";
    RolesPermissionsType["POST_PODS"] = "postPods";
    RolesPermissionsType["VIEW_STANDINGS"] = "viewStandings";
    RolesPermissionsType["SET_TICK"] = "setTick";
    RolesPermissionsType["SET_CONFIRMATION_TICK"] = "setConfirmationTick";
    RolesPermissionsType["VIEW_QR_CODE"] = "viewQrCode";
    RolesPermissionsType["WRITE_EMAIL"] = "writeEmail";
    RolesPermissionsType["ASSIGN_PERMISSIONS"] = "assignPermissions";
})(RolesPermissionsType || (RolesPermissionsType = {}));
